// extracted by mini-css-extract-plugin
module.exports = {"primary":"var(--primary)","secondary":"var(--secondary)","backgroundQuanto":"var(--backgroundQuanto)","currencyIncome":"#3bd072","currencyExpense":"#ff2240"};